'use no memo';

import { useFlags } from 'launchdarkly-react-client-sdk';

export const FLAG_NAME = {
  aaMenuToPurchase: 'aaMenuToPurchase',
  abSkipMobileBagModal: 'abSkipMobileBagModal',
  abPostOrderAdjustments: 'abPostOrderAdjustments',
  flagCheckoutAds: 'flagCheckoutAds',
  flagDefaultMods: 'flagDefaultMods',
  flagCatering: 'flagCatering',
  flagCateringInquiryForm: 'flagCateringInquiryForm',
  flagMarketingConsent: 'flagMarketingConsent',
  flagCateringServingsClassifications: 'flagCateringServingsClassifications',
  flagMpObnChannelBypass: 'flagMpObnChannelBypass',
  flagUpsell: 'upsellItemRecommendationsEnabled',
  flagZeroDollarCheckout: 'flagZeroDollarCheckout',
  googlePayGuestCheckout: 'googlePayGuestCheckout',
};

function useAssessFeatureFlag(flag: string) {
  const flags = useFlags();

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return flags[flag];
}

export default useAssessFeatureFlag;
